import React, { useEffect, useState } from "react";
import "../../Assets/Scss/Configuration.scss";
import { ReactComponent as File } from "../../Assets/SVG/File.svg";
import { ReactComponent as Add } from "../../Assets/SVG/Add.svg";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import {
  allLoanTypesURL,
  requestLeaveTypeURL,
  allPayrollTaxBandURL,
  allPayItemURL,
  getPrintoutPayItemsUrl,
  updatePrintoutPayitemUrl,
  updatePaystackAccUrl,
  getPaystackAccUrl,
  updatePayrollSettingsUrl,
  getPayrollSettingsUrl,
  getLoanSettingsUrl,
  updateLoanSettingsUrl,
  changeCompanyColorUrl,
  getAllEmploymentTypeUrl,
  allAddressTypesUrl,
  getAllWorkHoursUrl,
  getEmployeeNumSettingsUrl,
  updateEmployeeNumSettingsUrl,
  employeeByIDURL,
  companyByIdUrl,
  updateWorkDayTypeUrl,
  getOvertimeSettingsUrl,
  updateOvertimeSettingsUrl,
  allLegalEntitiesURL,
  allLocationURL,
  allBusinessUnitURL,
  allDepartmentURL,
  allDivisionURL,
  allPayLevelURL,
  allPayGradeURL,
  getCurrencyConvertUrl,
  updateCurrencyConvertUrl,
  getLeaveSettingsUrl,
  updateLeaveSettingsUrl,
} from "../../Library/URLs";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CreateLoanType from "./components/Loan/CreateLoanType";
import EditLoanType from "./components/Loan/EditLoanType";
import DeleteLoanType from "./components/Loan/DeleteLoan";
import CreateLeaveType from "./components/Leave/CreateLeave";
import EditLeaveType from "./components/Leave/EditLeave";
import DeleteLeaveType from "./components/Leave/DeleteLeave";
import EditTaxBands from "./components/Payroll/EditTaxBands";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import FoundationObject from "../FoundationObject/Foundation_Object";
import PayrollApprove from "./components/payrollApprover";
import ColorChange from "./components/Account/Theme";
import { useNavigate, useParams } from "react-router-dom";
import ChangeLogo from "./components/Account/Theme/ChangeLogo";
import {
  CreateAddressType,
  DeleteAddressType,
  EditAddressType,
} from "./components/Employees/AddressTypes";
import {
  CreateEmploymentType,
  DeleteEmploymentType,
  EditEmploymentType,
} from "./components/Employees/EmploymentTypes";
import {
  CreateWorkHour,
  DeleteWorkHours,
  EditWorkHour,
} from "./components/Employees/WorkHours";
import LeaveSettings from "./components/Leave/LeaveSettings";
import { payrollActions } from "../../store";
import allcurrencies from "../../currencies.json";
import { BsPlus, BsDash } from "react-icons/bs";
import moment from "moment";
import SelectField from "../../Components/SelectField";

const options = [
  "Employee Management",
  "Organizational Management",
  "Leave Management",
  "Payroll Management",
  "Loan Management",
  "Account Management",
];

const Config = () => {
  const unique_id = uuid();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const [loadEndpoint, setLoadEndpoint] = useState(false);
  const [openConfigurations, setOpenConfigurations] = useState([]);
  const [loanTypes, setLoanTypes] = useState([]);
  const [checkedLoan, setCheckedLoan] = useState("");
  const [createLoan, setCreateLoan] = useState(false);
  const [editLoan, setEditLoan] = useState(null);
  const [deleteLoan, setDeleteLoan] = useState(null);
  const [loanSettings, setLoanSettings] = useState({});
  const [loanSetLoading, setLoanSetLoading] = useState(false);
  const [currencyOptions, setCurrencyOptions] = useState([]);

  useEffect(() => {
    const currencies = allcurrencies;
    const options = currencies.map((currency) => ({
      value: currency.cc,
      label: `${currency.cc} - ${currency.name}`,
      symbol: currency.symbol,
    }));
    setCurrencyOptions(options);
  }, []);

  const [AllBusinessUnit, setAllBusinessUnit] = useState("");
  const [SelectedBusinessUnit, setSelectedBusinessUnit] = useState("");

  const [AllLegalEntity, setAllLegalEntity] = useState("");
  const [SelectedLegal, setSelectedLegal] = useState("");

  const [AllDivision, setAllDivision] = useState("");
  const [SelectedDivision, setSelectedDivision] = useState("");

  const [AllDepartment, setAllDepartment] = useState("");
  const [SelectedDepartment, setSelectedDepartment] = useState("");

  const [AllGrade, setAllGrade] = useState("");
  const [AllLevel, setAllLevel] = useState("");
  const [AllLocation, setAllLocation] = useState("");

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [checkedLeave, setCheckedLeave] = useState("");
  const [createLeave, setCreateLeave] = useState(false);
  const [editLeave, setEditLeave] = useState(null);
  const [deleteLeave, setDeleteLeave] = useState(null);
  const [leaveSettings, setLeaveSetting] = useState({
    require_approval: "",
    enforce_leave_rules: "",
    leave_overlapping_group: "",
    overlapping_limit: "",
    approvers: [
      {
        employee_id: "",
        level: "",
      },
    ],
  });

  const [taxBands, setTaxBands] = useState({});
  const [editTaxBands, setEditTaxBands] = useState(false);
  const [allPayItems, setAllPayItems] = useState([]);
  const [payLoading, setPayLoading] = useState(false);
  const [paySettings, setPaySettings] = useState({
    minimum_employment_days: "",
  });
  const [enabled, setEnabled] = useState(false);
  const [assignedList, setAssignedList] = useState([]);
  const [paySetLoading, setPaySetLoading] = useState(false);
  const [employee, setEmployee] = useState({});
  const [selectedCompany, setSelectedCompany] = useState({});

  const [paystackFormData, setPaystackFormData] = useState({
    paystack_public_key: "",
    paystack_secret_key: "",
  });
  const [color, setColor] = useState(User?.company_color_theme);
  const [changedColor, setChangedColor] = useState(User?.company_color_theme);
  const [accLoading, setAccLoading] = useState(false);
  const [themeLoad, setThemeLoad] = useState(false);
  const [logoLoad, setLogoLoad] = useState(false);
  const [selectedPic, setSelectedPic] = useState("");

  const [allAddressTypes, setAllAddressTypes] = useState([]);
  const [createAddressType, setCreateAddressType] = useState(false);
  const [editAddressType, setEditAddressType] = useState(null);
  const [deleteAddressType, setDeleteAddressType] = useState(null);

  const [allWorkHours, setAllWorkHours] = useState([]);
  const [createWorkHours, setCreateWorkHours] = useState(false);
  const [editWorkHours, setEditWorkHours] = useState(null);
  const [deleteWorkHours, setDeleteWorkHours] = useState(null);

  const [allEmploymentType, setAllEmploymentType] = useState([]);
  const [createEmploymentType, setCreateEmploymentType] = useState(false);
  const [editEmploymentType, setEditEmploymentType] = useState(null);
  const [deleteEmploymentType, setDeleteEmploymentType] = useState(null);
  const [employeeNumSettings, setEmployeeNumSettings] = useState({});
  const [numLoading, setNumLoading] = useState(false);
  const [overtimeSettings, setOvertimeSettings] = useState({});
  const [overtimeLoading, setOvertimeLoading] = useState(false);
  const [currenciesList, setCurrenciesList] = useState([
    {
      from_currency: { label: "", value: "" },
      to_currency: { label: "", value: "" },
      rate: "",
    },
  ]);

  const addCurrency = () => {
    let currenciesListCopy = [...currenciesList];
    currenciesListCopy.push({
      from_currency: { label: "", value: "" },
      to_currency: { label: "", value: "" },
      rate: "",
    });
    setCurrenciesList(currenciesListCopy);
  };

  const removeCurrency = (id) => {
    let assignedListCopy = [...currenciesList];
    if (currenciesList?.length > 1) {
      assignedListCopy.pop();
    }
    // assignedListCopy?.splice(id, 1);
    setCurrenciesList(assignedListCopy);
  };

  const handleCurrencyChange = (name, value, id) => {
    let assignListCopy = [...currenciesList];
    if (assignListCopy?.length > 0) {
      assignListCopy[id] = {
        ...assignListCopy[id],
        [name]: value,
      };
    }
    setCurrenciesList(assignListCopy);
  };

  const [companyInfo, setCompanyInfo] = useState({});
  const [workDayTypeLoad, setWorkDayTypeLoad] = useState(false);

  const dashboardTheme = window.localStorage.getItem("theme");
  const { companyid } = useParams();

  useEffect(() => {
    // FetchLoanTypes();
    // FetchLeaveTypes();
    // FetchPayrollTaxBands();
    // FetchPayItems();
    // FetchPayStack();
    // FetchPayrollSettings();
    // FetchLoanSettings();
    // FetchAddressTypes();
    // FetchEmploymentType();
    // FetchWorkHours();
    // FetchEmploymentNumSettings();
    GetEmployee();
    FetchCompany();
    // eslint-disable-next-line
  }, []);

  const employeeManagementEndpoints = () => {
    FetchAddressTypes();
    FetchEmploymentType();
    FetchWorkHours();
    FetchEmploymentNumSettings();
    FetchOvertimeSettings();
    FetchAllDepartment();
    FetchAllBusinessUnit();
    FetchAllLocation();
    FetchAllLegalEntity();
    FetchAllDivision();
    FetchAllLevel();
    FetchAllGrade();
  };

  const loanManagementEndpoints = () => {
    FetchLoanTypes();
    FetchLoanSettings();
  };

  const leaveManagementEndpoints = () => {
    FetchLeaveTypes();
    FetchLeaveSettings();
  };

  const payrollManagementEndpoints = () => {
    FetchPayrollTaxBands();
    FetchPayItems();
    FetchPayrollSettings();
    GetCurrencyConverter();
  };

  const accountManagementEndpoints = () => {
    FetchPayStack();
    fetchCompany();
  };

  useEffect(() => {
    if (openConfigurations === "Employee Management") {
      employeeManagementEndpoints();
    } else if (openConfigurations === "Leave Management") {
      leaveManagementEndpoints();
    } else if (openConfigurations === "Payroll Management") {
      payrollManagementEndpoints();
    } else if (openConfigurations === "Loan Management") {
      loanManagementEndpoints();
    } else if (openConfigurations === "Account Management") {
      accountManagementEndpoints();
    }
  }, [openConfigurations]);

  const FetchCompany = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(companyByIdUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          setColor(res?.data?.data?.color_theme);
          setSelectedPic(res?.data?.data?.logo_url);
          setSelectedCompany(res.data?.data);
          setCompanyInfo(res?.data?.data);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setThemeLoad(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchLeaveSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getLeaveSettingsUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          setLeaveSetting(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const [leaveSettingsLoad, setLeaveSettingsLoad] = useState(false);
  const UpdateLeaveSettings = async () => {
    setLeaveSettingsLoad(true);
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      ...leaveSettings,
    };
    await axios
      .post(updateLeaveSettingsUrl, data)
      .then((res) => {
        setLeaveSettingsLoad(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setLeaveSettingsLoad(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const GetCurrencyConverter = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getCurrencyConvertUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          // setAllBusinessUnit(res.data.data);
          // console.log("all Business unit", res.data);
          setCurrenciesList(res?.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  //organizational
  const FetchAllLegalEntity = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLegalEntitiesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllLegalEntity(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const FetchAllBusinessUnit = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allBusinessUnitURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllBusinessUnit(res.data.data);
          console.log("all Business unit", res.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchAllLocation = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLocationURL, data)
      .then((res) => {
        setAllLocation(res.data?.data);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };

  const FetchAllDivision = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDivisionURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllDivision(res.data.data);
        }
      })
      .catch((err) => {
        console.log("Get all division error", err.message);
      });
  };

  const FetchAllDepartment = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDepartmentURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllDepartment(res.data.data);
          // console.log('all department',res.data)
        }
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
      });
  };

  const FetchAllGrade = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayGradeURL, data)
      .then((res) => {
        setAllGrade(res.data);
      })
      .catch((err) => {
        // console.log('Get all pay grade error',err.message)
      });
  };

  const FetchAllLevel = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayLevelURL, data)
      .then((res) => {
        setAllLevel(res.data);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };

  const GetEmployee = async () => {
    // setLoading(true)
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      employee_id: proxyEmployee?.success ? proxyEmployee?.id : User?.id,
    };
    await axios
      .post(employeeByIDURL, data)
      .then((res) => {
        setEmployee(res.data);
      })
      .catch((err) => {
        // console.log('Get all payroll error',err.message)
      });
  };

  const ChangeTheme = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      color_theme: color,
    };
    setThemeLoad(true);
    await axios
      .post(changeCompanyColorUrl, data)
      .then((res) => {
        setThemeLoad(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          navigate("/configuration");
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setThemeLoad(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const fetchCompany = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(companyByIdUrl, data)
      .then((res) => {
        if (res.data) {
          setCompanyInfo(res?.data?.data);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchLoanTypes = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      for_admin_only: "Yes",
    };
    await axios
      .post(allLoanTypesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setLoanTypes(res.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchLeaveTypes = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(requestLeaveTypeURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setLeaveTypes(res.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchEmploymentNumSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getEmployeeNumSettingsUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          setEmployeeNumSettings(res.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const UpdateEmploymentNumSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      ...employeeNumSettings,
    };
    setNumLoading(true);
    await axios
      .post(updateEmployeeNumSettingsUrl, data)
      .then((res) => {
        setNumLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setNumLoading(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchPayrollTaxBands = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayrollTaxBandURL, data)
      .then((res) => {
        if (res.data) {
          setTaxBands(res.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchPayItems = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getPrintoutPayItemsUrl, data)
      .then((res) => {
        if (res.data.success) {
          const payItems = res.data?.data?.map((item) => {
            return {
              pay_item_id: item.pay_item_id,
              value: item?.status,
              name: item?.pay_item_name,
            };
          });
          setAllPayItems(payItems);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  // overtime
  const FetchOvertimeSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getOvertimeSettingsUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          setOvertimeSettings(res.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const UpdateOvertimeSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      ...overtimeSettings,
    };
    setOvertimeLoading(true);
    await axios
      .post(updateOvertimeSettingsUrl, data)
      .then((res) => {
        setOvertimeLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setOvertimeLoading(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const [currencyLoad, setCurrencyLoad] = useState(false);
  const UpdateCurrencyConverter = async () => {
    setCurrencyLoad(true);
    const data = {
      user_id: User.id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      rates: currenciesList,
    };
    await axios
      .post(updateCurrencyConvertUrl, data)
      .then((res) => {
        setCurrencyLoad(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
        setCurrencyLoad(false);
      });
  };

  const FetchPayStack = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getPaystackAccUrl, data)
      .then((res) => {
        setPaystackFormData({
          paystack_public_key: res.data?.public_key,
          paystack_secret_key: res.data?.secret_key,
        });
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchPayrollSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getPayrollSettingsUrl, data)
      .then((res) => {
        setPaySettings({
          ...paySettings,
          minimum_employment_days: res.data?.data?.minimum_employment_days,
        });
        setEnabled(res.data?.data?.require_approval === "Yes" ? true : false);
        setAssignedList(res.data?.data?.approvers);
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchLoanSettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getLoanSettingsUrl, data)
      .then((res) => {
        setLoanSettings(res?.data?.data);
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchAddressTypes = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allAddressTypesUrl, data)
      .then((res) => {
        if (res.data?.success) {
          setAllAddressTypes(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchEmploymentType = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getAllEmploymentTypeUrl, data)
      .then((res) => {
        if (res.data?.success) {
          setAllEmploymentType(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchWorkHours = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(getAllWorkHoursUrl, data)
      .then((res) => {
        if (res.data?.success) {
          setAllWorkHours(res.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const UpdatePrintoutPayItems = async () => {
    // setLoading(true)
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      // employee_id: Personal?.id,
      printout_pay_list: allPayItems,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    setPayLoading(true);
    await axios
      .post(updatePrintoutPayitemUrl, data)
      .then((res) => {
        if (res.data.success === false) {
          toast.error(res.data.message);
        }
        if (res.data.success === true) {
          toast.success(res.data.data);
        }
        setPayLoading(false);
      })
      .catch((err) => {
        setPayLoading(false);
      });
  };

  const updatePaystackAcc = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      ...paystackFormData,
    };
    setAccLoading(true);
    await axios
      .post(updatePaystackAccUrl, data)
      .then((res) => {
        setAccLoading(false);
        if (res.data?.success) {
          toast.success(res?.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setAccLoading(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const updateWorkDayType = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      work_day_type: companyInfo?.work_day_type,
      custom_number_of_days: companyInfo?.custom_number_of_days,
    };
    setWorkDayTypeLoad(true);
    await axios
      .post(updateWorkDayTypeUrl, data)
      .then((res) => {
        setWorkDayTypeLoad(false);
        if (res.data?.success) {
          toast.success(res?.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setWorkDayTypeLoad(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const updatePaySettings = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      ...paySettings,
      approvers: assignedList,
      require_approval: enabled ? "Yes" : "No",
    };
    setPaySetLoading(true);
    await axios
      .post(updatePayrollSettingsUrl, data)
      .then((res) => {
        setPaySetLoading(false);
        if (res.data?.success) {
          toast.success(res?.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setPaySetLoading(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const updateLoanSettings = async () => {
    const { monthly_repayment_threshold, request_when_owing } = loanSettings;
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
      monthly_repayment_threshold,
      request_when_owing,
    };
    setLoanSetLoading(true);
    await axios
      .post(updateLoanSettingsUrl, data)
      .then((res) => {
        setLoanSetLoading(false);
        if (res.data?.success) {
          toast.success(res?.data?.data);
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        setLoanSetLoading(false);
        // console.log('Get all Business unit error',err.message)
      });
  };

  const handleChange = (configure) => {
    if (openConfigurations === configure) {
      setOpenConfigurations("");
    } else {
      if (configure === "Organizational Management") {
        if (!loadEndpoint) {
          setLoadEndpoint(true);
        }
      }
      setOpenConfigurations(configure);
    }
  };

  const handlePayItems = (id) => {
    let selectedPayCopy = allPayItems;
    let payObj = selectedPayCopy?.find((item) => item.pay_item_id === id);
    const payObjIndex = selectedPayCopy.findIndex(
      (pay) => pay.pay_item_id === id
    );
    payObj = {
      ...payObj,
      value: payObj?.value === "Included" ? "Excluded" : "Included",
    };
    selectedPayCopy[payObjIndex] = payObj;
    setAllPayItems(selectedPayCopy);
  };

  return (
    <div className="Configure_Wrapper">
      <CreateLoanType
        open={createLoan}
        handleClose={() => setCreateLoan(false)}
        updateLoanTypes={FetchLoanTypes}
      />
      <EditLoanType
        open={editLoan !== null}
        updateLoanTypes={FetchLoanTypes}
        handleClose={() => setEditLoan(null)}
        loanType={loanTypes?.find((item) => item.id === editLoan)}
      />
      <DeleteLoanType
        open={deleteLoan !== null}
        updateLoanTypes={FetchLoanTypes}
        handleClose={() => setDeleteLoan(null)}
        loanType={deleteLoan}
      />
      <CreateLeaveType
        open={createLeave}
        handleClose={() => setCreateLeave(false)}
        updateLeaveTypes={FetchLeaveTypes}
      />
      <EditLeaveType
        open={editLeave !== null}
        updateLeaveTypes={FetchLeaveTypes}
        handleClose={() => setEditLeave(null)}
        leave_type={leaveTypes?.find((item) => item.id === editLeave)}
      />
      <DeleteLeaveType
        open={deleteLeave !== null}
        updateLeaveTypes={FetchLeaveTypes}
        handleClose={() => setDeleteLeave(null)}
        leaveType={deleteLeave}
      />
      <EditTaxBands
        open={editTaxBands}
        updateTaxBands={FetchPayrollTaxBands}
        handleClose={() => setEditTaxBands(false)}
        taxes={taxBands}
      />
      <CreateAddressType
        open={createAddressType}
        handleClose={() => setCreateAddressType(false)}
        updateAddressTypes={FetchAddressTypes}
      />
      <EditAddressType
        open={editAddressType !== null}
        handleClose={() => setEditAddressType(null)}
        updateAddressList={FetchAddressTypes}
        address_type={allAddressTypes?.find(
          (item) => item?.id === editAddressType
        )}
      />
      <DeleteAddressType
        open={deleteAddressType !== null}
        handleClose={() => setDeleteAddressType(null)}
        updateAddressType={FetchAddressTypes}
        addressType={deleteAddressType}
      />
      <CreateEmploymentType
        open={createEmploymentType}
        handleClose={() => setCreateEmploymentType(false)}
        updateEmploymentTypes={FetchEmploymentType}
      />
      <EditEmploymentType
        open={editEmploymentType !== null}
        handleClose={() => setEditEmploymentType(null)}
        updateEmploymentList={FetchEmploymentType}
        employment_type={editEmploymentType}
      />
      <DeleteEmploymentType
        open={deleteEmploymentType !== null}
        handleClose={() => setDeleteEmploymentType(null)}
        updateEmploymentType={FetchEmploymentType}
        employmentType={deleteEmploymentType}
      />
      <CreateWorkHour
        open={createWorkHours}
        handleClose={() => setCreateWorkHours(false)}
        updateWorkHour={FetchWorkHours}
      />
      <EditWorkHour
        open={editWorkHours !== null}
        handleClose={() => setEditWorkHours(null)}
        updateWorkHourList={FetchWorkHours}
        work_hour={editWorkHours}
      />
      <DeleteWorkHours
        open={deleteWorkHours !== null}
        handleClose={() => setDeleteWorkHours(null)}
        updateWorkHourList={FetchWorkHours}
        workHour={deleteWorkHours}
      />
      {/* <div
        className="top_contain"
        style={{
          backgroundColor: dashboardTheme ? dashboardTheme + "1F" : "#13ABF41F",
        }}
      >
        <p>Admin Centre</p>
        <h4>Config Panel</h4>
      </div> */}
      <div className="configurations">
        {options?.map((item, index) => (
          <div
            key={item}
            className={`${openConfigurations === item && "active"} list_box`}
          >
            <div className="top_sect">
              <div className="Left">
                <File />
                <p className="configure_name">{item} </p>
              </div>
              <div className="Right">
                {index === 4 ? (
                  <span
                    onClick={() => {
                      setCreateLoan(true);
                    }}
                  >
                    <Add />
                  </span>
                ) : (
                  index === 2 && (
                    <span
                      onClick={() => {
                        setCreateLeave(true);
                      }}
                    >
                      <Add />
                    </span>
                  )
                )}
                {openConfigurations === item ? (
                  <BiChevronUp
                    opacity={0.5}
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleChange(item)}
                  />
                ) : (
                  <BiChevronDown
                    opacity={0.5}
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleChange(item)}
                  />
                )}
              </div>
            </div>
            <div
              className={`toggle ${
                openConfigurations === item && "list-active"
              }`}
            >
              {/*Loan Type configurations */}
              {item === options[0] && openConfigurations === item && (
                <div>
                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }} className="add_btn">
                      Address Types
                      <span
                        onClick={() => {
                          setCreateAddressType(true);
                        }}
                      >
                        <Add />
                      </span>
                    </p>
                    <table>
                      <thead>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Action</th>
                        {/* <th></th> */}
                      </thead>
                      <tbody>
                        {allAddressTypes?.map((addressType) => (
                          <tr key={addressType?.id}>
                            <td className="Check_Box">
                              <label htmlFor="alternative">
                                {addressType?.type}
                              </label>
                            </td>
                            <td>{addressType?.status} </td>
                            <td className="Action_Btn">
                              <p
                                className="edit"
                                onClick={() =>
                                  setEditAddressType(addressType?.id)
                                }
                              >
                                Edit
                              </p>
                              <p>.</p>
                              <p
                                className="delete"
                                onClick={() =>
                                  setDeleteAddressType(addressType?.id)
                                }
                              >
                                Delete
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }} className="add_btn">
                      Employment Types
                      <span
                        onClick={() => {
                          setCreateEmploymentType(true);
                        }}
                      >
                        <Add />
                      </span>
                    </p>
                    <table>
                      <thead>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Action</th>
                      </thead>
                      <tbody>
                        {allEmploymentType?.map((employmentType) => (
                          <tr key={employmentType?.id}>
                            <td className="Check_Box">
                              <label htmlFor="alternative">
                                {employmentType?.type}
                              </label>
                            </td>
                            <td>{employmentType?.status} </td>
                            <td className="Action_Btn">
                              <p
                                className="edit"
                                onClick={() =>
                                  setEditEmploymentType(employmentType)
                                }
                              >
                                Edit
                              </p>
                              <p>.</p>
                              <p
                                className="delete"
                                onClick={() =>
                                  setDeleteEmploymentType(employmentType?.id)
                                }
                              >
                                Delete
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }} className="add_btn">
                      Work Hours
                      <span
                        onClick={() => {
                          setCreateWorkHours(true);
                        }}
                      >
                        <Add />
                      </span>
                    </p>
                    <table>
                      <thead>
                        <th>Type</th>
                        <th>Hours</th>
                        <th>Status</th>
                        <th>Action</th>
                      </thead>
                      <tbody>
                        {allWorkHours?.map((workhour) => (
                          <tr key={workhour?.id}>
                            <td className="Check_Box">
                              <label htmlFor="alternative">
                                {workhour?.day_type}
                              </label>
                            </td>
                            <td>{workhour?.hours} </td>
                            <td>{workhour?.status} </td>
                            <td className="Action_Btn">
                              <p
                                className="edit"
                                onClick={() => setEditWorkHours(workhour)}
                              >
                                Edit
                              </p>
                              <p>.</p>
                              <p
                                className="delete"
                                onClick={() => setDeleteWorkHours(workhour?.id)}
                              >
                                Delete
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>
                      Employee Number Settings
                    </p>
                    <div
                      className="Acc_Content_Wrap"
                      style={{ margin: "1rem 0" }}
                    >
                      <div className="Check_Box">
                        <input
                          name="is_alphanumeric"
                          checked={
                            employeeNumSettings?.is_alphanumeric === "Yes"
                          }
                          onChange={(e) =>
                            setEmployeeNumSettings({
                              ...employeeNumSettings,
                              is_alphanumeric:
                                employeeNumSettings?.is_alphanumeric === "Yes"
                                  ? "No"
                                  : "Yes",
                            })
                          }
                          type="checkbox"
                        />
                        <label htmlFor="">Is AlphaNumeric</label>
                      </div>
                    </div>
                    <div className="Acc_Content_Wrap">
                      <div className="Box">
                        <label htmlFor="">Prefix</label>
                        <input
                          name="prefix"
                          value={employeeNumSettings?.prefix}
                          onChange={(e) =>
                            setEmployeeNumSettings({
                              ...employeeNumSettings,
                              prefix: e.target.value,
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="Acc_btn_wrap">
                      <button
                        className="Acc_edit"
                        onClick={UpdateEmploymentNumSettings}
                      >
                        {numLoading === false ? (
                          "Update"
                        ) : (
                          <CircularProgress color="inherit" size={14} />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Update Overtime Settings */}
                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>Overtime Settings</p>
                    <div className="">
                      <div>
                        <div
                          className="Acc_Content_Wrap"
                          style={{ margin: "1rem 0" }}
                        >
                          <div className="Check_Box">
                            <input
                              name="enable_overtime"
                              checked={
                                overtimeSettings?.enable_overtime === "Yes"
                              }
                              onChange={(e) =>
                                setOvertimeSettings({
                                  ...overtimeSettings,
                                  enable_overtime:
                                    overtimeSettings?.enable_overtime === "Yes"
                                      ? "No"
                                      : "Yes",
                                })
                              }
                              type="checkbox"
                            />
                            <label htmlFor="">Enable Overtime</label>
                          </div>
                        </div>
                        <div className="Acc_Content_Wrap">
                          <div className="Box">
                            <label htmlFor="">Overtime Rate</label>
                            <input
                              name="overtime_rate"
                              value={overtimeSettings?.overtime_rate}
                              onChange={(e) =>
                                setOvertimeSettings({
                                  ...overtimeSettings,
                                  overtime_rate: e.target.value,
                                })
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="btn_wrap">
                          <button
                            className="Payroll_app_edit"
                            onClick={UpdateOvertimeSettings}
                            style={{
                              backgroundColor: dashboardTheme
                                ? dashboardTheme
                                : "#13ABF4",
                            }}
                          >
                            {overtimeLoading === false ? (
                              "Update"
                            ) : (
                              <CircularProgress color="inherit" size={14} />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/*Organisationals configurations */}
              {item === options[1] && openConfigurations === item && (
                <div className={`bottom_sect`}>
                  <FoundationObject loadEndpoint={loadEndpoint} />
                </div>
              )}

              {/*Leave Type configurations */}
              {item === options[2] && openConfigurations === item && (
                <>
                  <div className={`bottom_sect`}>
                    <table>
                      <thead>
                        <th>Name</th>
                        {/* <th>Description</th> */}
                        <th>Quota(Days)</th>
                        {/* <th>Leave Allowance</th> */}
                        <th>Eligible Type Name</th>
                        <th>Action</th>
                        {/* <th></th> */}
                      </thead>
                      <tbody>
                        {leaveTypes?.map((leave) => (
                          <tr key={leave?.id}>
                            <td className="Check_Box">
                              {/* <input
                                value={checkedLeave === leave?.id}
                                onChange={(e) =>
                                  setCheckedLeave(e.currentTarget.name)
                                }
                                type="checkbox"
                                name={leave?.id}
                                checked={checkedLeave === leave?.id}
                                id="alternative"
                              /> */}
                              <label htmlFor="alternative">{leave?.name}</label>
                            </td>
                            {/* <td>{leave?.description} </td> */}
                            <td>{leave?.max_day_duration} </td>
                            {/* <td>{leave?.leave_allowance} </td> */}
                            <td>{leave?.eligible_type_name} </td>
                            <td className="Action_Btn">
                              <p
                                className="edit"
                                onClick={() => setEditLeave(leave?.id)}
                              >
                                Edit
                              </p>
                              <p>.</p>
                              <p
                                className="delete"
                                onClick={() => setDeleteLeave(leave?.id)}
                              >
                                Delete
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="bottom_sect">
                    <LeaveSettings
                      leaveSettings={leaveSettings}
                      setLeaveSetting={setLeaveSetting}
                      updateSettings={UpdateLeaveSettings}
                      isLoading={leaveSettingsLoad}
                    />
                  </div>
                </>
              )}

              {/*Payroll Tax bands configuration */}
              {item === options[3] && openConfigurations === item && (
                <div>
                  <div className={`bottom_sect`}>
                    <div className="list_items_tax_bands">
                      <table>
                        <thead>
                          <th>Payroll Tax Bands</th>
                          <th>Band Rate</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span className="tax-label">First</span> &#8358;
                              {taxBands?.first_band}{" "}
                            </td>
                            <td>{taxBands?.first_band_rate}%</td>
                          </tr>
                          <tr>
                            <td>
                              <span className="tax-label">Next</span> &#8358;
                              {taxBands?.second_band}{" "}
                            </td>
                            <td>{taxBands?.second_band_rate}%</td>
                          </tr>
                          <tr>
                            <td>
                              <span className="tax-label">Next</span> &#8358;
                              {taxBands?.third_band}{" "}
                            </td>
                            <td>{taxBands?.third_band_rate}%</td>
                          </tr>
                          <tr>
                            <td>
                              <span className="tax-label">Next</span> &#8358;
                              {taxBands?.fourth_band}{" "}
                            </td>
                            <td>{taxBands?.fourth_band_rate}%</td>
                          </tr>
                          <tr>
                            <td>
                              <span className="tax-label">Next</span> &#8358;
                              {taxBands?.fifth_band}{" "}
                            </td>
                            <td>{taxBands?.fifth_band_rate}%</td>
                          </tr>
                          <tr>
                            <td>
                              <span className="tax-label">Next</span> &#8358;
                              {taxBands?.sixth_band}{" "}
                            </td>
                            <td>{taxBands?.sixth_band_rate}%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="btn_wrap">
                        <button
                          className="edit"
                          onClick={() => setEditTaxBands(true)}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>Pay Items</p>
                    <ul className="list_items">
                      {allPayItems.map((item, index) => (
                        <li key={item?.pay_item_id}>
                          <div className="Check_Box">
                            <input
                              value={allPayItems[index]?.value === "Included"}
                              onChange={() => handlePayItems(item.pay_item_id)}
                              type="checkbox"
                              name={item?.name}
                              defaultChecked={
                                allPayItems[index]?.value === "Included"
                              }
                              id="alternative"
                            />
                            <label htmlFor="alternative">{item?.name}</label>
                          </div>
                        </li>
                      ))}
                      <li className="btn_wrap">
                        <button
                          className="edit"
                          onClick={UpdatePrintoutPayItems}
                        >
                          {payLoading === false ? (
                            "Update"
                          ) : (
                            <CircularProgress color="inherit" size={14} />
                          )}
                        </button>
                      </li>
                    </ul>
                  </div> */}

                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>Payroll Settings</p>
                    <div className="Acc_Content_Wrap">
                      <div className="Box">
                        <label htmlFor="">Minimum Employment Days</label>
                        <input
                          name="minimum_employment_days"
                          value={paySettings?.minimum_employment_days}
                          onChange={(e) =>
                            setPaySettings({
                              ...paySettings,
                              minimum_employment_days: e.target.value,
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="Acc_btn_wrap">
                      <button className="Acc_edit" onClick={updatePaySettings}>
                        {paySetLoading === false ? (
                          "Update"
                        ) : (
                          <CircularProgress color="inherit" size={14} />
                        )}
                      </button>
                    </div>
                  </div>

                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>Convert Currencies</p>
                    {currenciesList?.map((currency, id) => (
                      <div key={id}>
                        <div className="Acc_Content_Wrap">
                          <div className="Box">
                            <label htmlFor="">From Currency</label>
                            <SelectField
                              options={currencyOptions}
                              value={currencyOptions?.find(
                                (item) => item?.value === currency.from_currency
                              )}
                              onChange={(val) =>
                                handleCurrencyChange(
                                  "from_currency",
                                  val?.value,
                                  id
                                )
                              }
                              name="currency"
                            />
                          </div>
                          <div className="Box">
                            <label htmlFor="">To Currency</label>
                            <SelectField
                              options={currencyOptions}
                              value={currencyOptions?.find(
                                (item) => item?.value === currency.to_currency
                              )}
                              onChange={(val) =>
                                handleCurrencyChange(
                                  "to_currency",
                                  val?.value,
                                  id
                                )
                              }
                              name="currency"
                            />
                          </div>
                        </div>
                        <div className="Acc_Content_Wrap">
                          <div className="Box grid_input">
                            <label htmlFor="">Currency Rate</label>
                            <input
                              name="minimum_employment_days"
                              style={{ width: "100%" }}
                              // value={`${currencyOptions?.find(
                              //   (item) => item?.value === currency?.to_currency
                              // )?.symbol??""} ${currency.rate}`}
                              value={currency.rate}
                              onChange={(e) =>
                                handleCurrencyChange("rate", e.target.value, id)
                              }
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div
                      className="btn_wrap"
                      style={{ display: "flex", gap: "1rem" }}
                    >
                      <button className="RateBtn" onClick={removeCurrency}>
                        <BsDash />
                      </button>
                      <button
                        className="RateBtn add_rate"
                        onClick={addCurrency}
                        style={{
                          backgroundColor: dashboardTheme
                            ? dashboardTheme
                            : "#13ABF4",
                        }}
                      >
                        <BsPlus />
                      </button>
                    </div>
                    <div className="btn_wrap" style={{ marginTop: "1rem" }}>
                      <button
                        className="Payroll_app_edit"
                        onClick={UpdateCurrencyConverter}
                      >
                        {currencyLoad === false ? (
                          "Update"
                        ) : (
                          <CircularProgress color="inherit" size={14} />
                        )}
                      </button>
                    </div>
                  </div>

                  <div className={`bottom_sect`}>
                    <div>
                      <PayrollApprove
                        assignedList={assignedList}
                        setAssignedList={setAssignedList}
                        enabled={enabled}
                        setEnabled={setEnabled}
                        updatePaySettings={updatePaySettings}
                        paySetLoading={paySetLoading}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*Loan Type configurations */}
              {item === options[4] && openConfigurations === item && (
                <div>
                  <div className={`bottom_sect`}>
                    <table>
                      <thead>
                        <th>Name</th>
                        <th>Repayment Type</th>
                        <th>Interest Rate Type</th>
                        <th>Action</th>
                        {/* <th></th> */}
                      </thead>
                      <tbody>
                        {loanTypes?.map((loan) => (
                          <tr key={loan?.id}>
                            <td>
                              <div className="Check_Box">
                                {/* <input
                                  value={checkedLoan === loan?.id}
                                  onChange={(e) =>
                                    setCheckedLoan(e.currentTarget.name)
                                  }
                                  type="checkbox"
                                  name={loan?.id}
                                  checked={checkedLoan === loan?.id}
                                  id="alternative"
                                /> */}
                                <label htmlFor="alternative">
                                  {loan?.type}
                                </label>
                              </div>
                            </td>
                            <td>{loan?.repayment_type}</td>
                            <td>{loan?.interest_rate_type} </td>
                            <td className="Action_Btn">
                              <p
                                className="edit"
                                onClick={() => setEditLoan(loan?.id)}
                              >
                                Edit
                              </p>
                              <p>.</p>
                              <p
                                className="delete"
                                onClick={() => setDeleteLoan(loan?.id)}
                              >
                                Delete
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* <ul className="list_items">
                      {loanTypes?.map((loan) => (
                        <li key={loan?.id}>
                          <div className="Check_Box">
                            <input
                              value={checkedLoan === loan?.id}
                              onChange={(e) =>
                                setCheckedLoan(e.currentTarget.name)
                              }
                              type="checkbox"
                              name={loan?.id}
                              checked={checkedLoan === loan?.id}
                              id="alternative"
                            />
                            <label htmlFor="alternative">{loan?.type}</label>
                          </div>
                        </li>
                      ))}
                      <li className="btn_wrap">
                        {employee?.permissions?.data?.edit_loan_type === "1" && (
                          <button
                            className="edit"
                            
                          >
                            Edit
                          </button>
                        )}
                        <button
                          className="delete"
                          
                        >
                          Delete
                        </button>
                      </li>
                    </ul> */}
                  </div>
                  <div className={`bottom_sect`}>
                    <p style={{ marginBottom: "1rem" }}>Loan Settings</p>
                    <div className="Acc_Content_Wrap">
                      <div className="Box">
                        <label htmlFor="">Monthly Repayment Threshold(%)</label>
                        <input
                          name="monthly_repayment_threshold"
                          value={loanSettings?.monthly_repayment_threshold}
                          onChange={(e) =>
                            setLoanSettings({
                              ...loanSettings,
                              monthly_repayment_threshold: e.target.value,
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="Radio_Contain">
                      <div className="Box">
                        <label htmlFor="">
                          Allow Employee To Request While Owing
                        </label>
                      </div>
                      <div className="Radio_btn">
                        <span>
                          <input
                            type="radio"
                            id="no"
                            name="request_when_owing"
                            checked={loanSettings?.request_when_owing === "No"}
                            onChange={(e) =>
                              setLoanSettings({
                                ...loanSettings,
                                request_when_owing: e.target.value,
                              })
                            }
                            value="No"
                          />
                          <label for="No">No</label>
                        </span>
                        <span>
                          <input
                            type="radio"
                            id="yes"
                            name="request_when_owing"
                            checked={loanSettings?.request_when_owing === "Yes"}
                            value="Yes"
                            onChange={(e) =>
                              setLoanSettings({
                                ...loanSettings,
                                request_when_owing: e.target.value,
                              })
                            }
                          />
                          <label for="Yes">Yes</label>
                        </span>
                      </div>
                    </div>
                    <div className="Acc_btn_wrap">
                      <button className="Acc_edit" onClick={updateLoanSettings}>
                        {loanSetLoading === false ? (
                          "Update"
                        ) : (
                          <CircularProgress color="inherit" size={14} />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/*Account configurations */}
              {item === options[5] && openConfigurations === item && (
                <div className={`bottom_sect`}>
                  <div className="Acc_Content_Wrap">
                    <div className="Box">
                      <label htmlFor="">Public Key</label>
                      <input
                        name="paystack_public_key"
                        value={paystackFormData?.paystack_public_key}
                        onChange={(e) =>
                          setPaystackFormData({
                            ...paystackFormData,
                            paystack_public_key: e.target.value,
                          })
                        }
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="Acc_Content_Wrap">
                    <div className="Box">
                      <label htmlFor="">Private Key</label>
                      <input
                        name="paystack_secret_key"
                        value={paystackFormData?.paystack_secret_key}
                        onChange={(e) =>
                          setPaystackFormData({
                            ...paystackFormData,
                            paystack_secret_key: e.target.value,
                          })
                        }
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="Acc_btn_wrap">
                    <button className="Acc_edit" onClick={updatePaystackAcc}>
                      {accLoading === false ? (
                        "Update"
                      ) : (
                        <CircularProgress color="inherit" size={14} />
                      )}
                    </button>
                  </div>
                  <div>
                    <ChangeLogo
                      selectedPic={selectedPic}
                      setSelectedPic={setSelectedPic}
                      loading={logoLoad}
                      setLoading={setLogoLoad}
                    />
                  </div>
                  <div>
                    <ColorChange
                      color={color}
                      setColor={setColor}
                      submit={ChangeTheme}
                      loading={themeLoad}
                      setChangedColor={setChangedColor}
                    />
                  </div>
                  <div className="Acc_Content_Wrap">
                    <div className="Box">
                      <label htmlFor="work_day_type">Work Pay Day</label>
                      <select
                        name="work_day_type"
                        id="work_day_type"
                        className={
                          companyInfo.work_day_type === "Custom" && "input_full"
                        }
                        value={companyInfo?.work_day_type}
                        onChange={(e) =>
                          setCompanyInfo({
                            ...companyInfo,
                            work_day_type: e.target.value,
                          })
                        }
                      >
                        <option value="" hidden>
                          Pay Day
                        </option>
                        <option value="Business">Business</option>
                        <option value="Calendar">Calendar</option>
                        <option value="Custom">Custom Days</option>
                      </select>
                    </div>
                  </div>
                  <div className="Acc_Content_Wrap">
                    {companyInfo?.work_day_type === "Custom" && (
                      <div className="Box">
                        <label htmlFor="work_day_type">Number of days</label>
                        <input
                          type="text"
                          className="input_full"
                          value={companyInfo?.custom_number_of_days}
                          onChange={(e) =>
                            setCompanyInfo({
                              ...companyInfo,
                              custom_number_of_days: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="btn_wrap">
                    <button
                      className="Payroll_app_edit"
                      onClick={updateWorkDayType}
                    >
                      {workDayTypeLoad === false ? (
                        "Update"
                      ) : (
                        <CircularProgress color="inherit" size={14} />
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Config;
